// IE 2026 10 25 / ODOO-348925 (заказ Игоря: вкладка «Граф зв’язків» схемы PLAN-MAP-SET v3 — атрибут формы AttrSchemeGraph)
// Чистая логика атрибута AttrSchemeGraph (без Vue, DOM и стора): из двух табличных частей документа — узлы (doc.nodes, иерархия вложенностью строк attrs)
// и связи (doc.edges, плоская: концы — ключи узлов source.name / target.name) — собирает data_graph в формате бэка каскада (cascade.graph_data_model):
// { nodes: [{key, attributes: {label, x, y, size, color, forceLabel, icon?, hollow?, row: {binding, rid, key_binding}, doc?}}], edges: [{key, source, target,
// attributes: {size, color, label, row: {binding, rid, index}}}], graphContext: [{type: 'rect', x0, y0, x1, y1, title, anchor: {nodes, depth}, row?}], legend: {items: []} }.
// Рисует штатный AttrGraph (тот же вид, что «Каскад розрахунку»). Узел графа — лист doc.nodes (строка без дочерних строк); строка с дочерними — группа:
// прямоугольник вокруг своих узлов (вложенные группы — прямоугольники в прямоугольниках). Раскладка — dagre (Sugiyama: network simplex, слева направо,
// группы — compound-кластеры), та же библиотека и те же умолчания, что graphLayoutStd; y ↦ −y (ось sigma, как у бэка каскада).
// Связь на несуществующий узел (или на группу) не рисуется и попадает в dangling; петля не рисуется (loops); дубли пары — одно ребро с числом «×n».
// Граф только показывает документ: исходные строки не меняются. Выключатель fe.ux.schemeGraph (дефолт ВКЛ) читает компонент, сюда приходит setting(key, def).
// Юнит-тест: node --test tests/unit/schemeGraph.test.mjs
import dagre from 'dagre'

export const SG_FLAG = 'fe.ux.schemeGraph'   // IE 2026 10 25 / ODOO-348925
export function schemeGraphOn(setting) {
    try { return (typeof setting === 'function' ? setting(SG_FLAG, true) : true) !== false } catch (e) { return true }
}

// раскладка: та же библиотека и ранжирование, что graphLayoutStd (dagre, network simplex); nodesep шире (40 вместо 22) — место под заголовок прямоугольника группы;
// edgesep 36 — между рамками соседних групп (рамки кластеров dagre — фиктивные узлы, их разводит edgesep); шаг слоя и габарит узла — под подпись справа от узла
export const SG_LAYOUT = Object.freeze({ rankdir: 'LR', ranker: 'network-simplex', nodesep: 40, ranksep: 70, edgesep: 36, marginx: 20, marginy: 20,
    nodeSize: 10, nodeH: 30, charW: 7.5, labelPad: 34, bucket: 8, rectPad: 6, rectStep: 5 })
// IE 2026 10 25 / ODOO-348925: подпись узла не ложится на заголовок группы. Заголовок прямоугольника AttrGraph.drawGraphContext рисует в ЭКРАННЫХ px
// (полоса ty + 2 … ty + 20 от верхней грани, текст от tx + 8), место подписи узла AttrGraph.labelPlace выбирает тоже в px (снизу / сверху / справа),
// а отступ рамки над первым узлом (рамка кластера dagre + rectPad) задан в единицах графа и при вписывании графа в окно сжимается (проба dev02 25.10:
// ~34 px при полосе заголовка 20 px и подписи «сверху» ~28 px) — подпись «сверху», которую labelPlace берёт, когда снизу и справа лежат связи, накрывала
// заголовок («План КАМ» поверх «Плани введення (люди)»). Прямоугольник группы несёт labelClear: true — labelPlace добавляет месту подписи, пересекающему
// полосу заголовка (sgTitleBand), штраф sgTitleHit больше любого другого: подпись уходит вниз / вправо, если там чисто. Выключатель
// fe.ux.schemeGraphTitleClear (дефолт ВКЛ): выключен — прямоугольники без labelClear, подписи как прежде. Граф без групп прямоугольников не имеет — не меняется.
export const SG_TITLE_FLAG = 'fe.ux.schemeGraphTitleClear'   // IE 2026 10 25 / ODOO-348925
export function schemeGraphTitleClearOn(setting) {   // IE 2026 10 25 / ODOO-348925
    try { return (typeof setting === 'function' ? setting(SG_TITLE_FLAG, true) : true) !== false } catch (e) { return true }
}
// геометрия полосы заголовка — как в drawGraphContext: dx — отступ текста от tx, top / h — полоса по вертикали от ty, cut — правое поле рамки,
// minW — наименьшая ширина полосы, gap — зазор вокруг полосы, penalty — штраф места подписи на полосе (больше суммы прочих штрафов labelPlace)
export const SG_TITLE = Object.freeze({ dx: 8, top: 2, h: 18, cut: 8, minW: 12, gap: 2, penalty: 1000 })   // IE 2026 10 25 / ODOO-348925
// полоса заголовка прямоугольника на экране: box — {rx, ry, rw, rh} (AttrGraph.rectBoxes), titleW — ширина текста (measureText шрифтом строки),
// view — {left, top}: видимый угол контейнера (заголовок липнет к нему при прокрутке), iconW — иконка записи перед заголовком; null — заголовок не рисуется
export function sgTitleBand(box, titleW, view, iconW = 0, o = SG_TITLE) {   // IE 2026 10 25 / ODOO-348925
    if (!box || !(box.rw > 0) || !(box.rh > 0)) return null
    const vL = view && Number.isFinite(view.left) ? view.left : -Infinity, vT = view && Number.isFinite(view.top) ? view.top : -Infinity
    const tx = Math.min(Math.max(box.rx, vL), box.rx + box.rw - o.cut), ty = Math.min(Math.max(box.ry, vT), box.ry + box.rh - o.h)
    if (!(ty + 16 <= box.ry + box.rh && tx + o.dx <= box.rx + box.rw)) return null
    const x = tx + o.dx + (iconW || 0)
    const w = Math.max(Math.min(Number(titleW) || 0, box.rx + box.rw - o.cut - x), o.minW)
    return { x0: tx + o.dx - o.gap, y0: ty + o.top - o.gap, x1: x + w + o.gap, y1: ty + o.top + o.h + o.gap }
}
export function sgBoxOverlap(a, b) {   // площадь пересечения прямоугольников {x0, y0, x1, y1}; 0 — не пересекаются
    if (!a || !b) return 0
    return Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)) * Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0))
}
// штраф места подписи (прямоугольник {x0, y0, x1, y1}) за полосы заголовков групп: penalty за каждую задетую полосу
export function sgTitleHit(lbox, bands, o = SG_TITLE) {   // IE 2026 10 25 / ODOO-348925
    let sc = 0
    for (const b of Array.isArray(bands) ? bands : []) if (sgBoxOverlap(lbox, b) > 0) sc += o.penalty
    return sc
}
// IE 2026 10 25 / ODOO-348925 (замечание ie-dm7 #104334, снимок *_links_graph_late_*: на вписанном масштабе подпись узла и подпись связи наезжают на заголовок группы;
// подписи связей у «Узгоджений план» ложатся друг на друга). Масштаб ниже 0.2: отступ рамки над первым узлом в единицах графа (~59) сжимается до ~10 px и меньше —
// полоса заголовка (22 px) ложится на сам узел, штраф места подписи (p009) уже не спасает. Решение — запас под заголовок в ЭКРАННЫХ px: AttrGraph.rectBoxes поднимает
// верхнюю грань прямоугольника группы с titleRoom так, чтобы полоса заголовка была выше верха узлов группы (и рамок вложенных групп) при любом масштабе.
// Раскладка (координаты узлов) не меняется. Выключатель fe.ux.schemeGraphTitleRoom (дефолт ВКЛ): выключен — прямоугольники без titleRoom, рамки как прежде.
export const SG_ROOM_FLAG = 'fe.ux.schemeGraphTitleRoom'   // IE 2026 10 25 / ODOO-348925
export function schemeGraphTitleRoomOn(setting) {   // IE 2026 10 25 / ODOO-348925
    try { return (typeof setting === 'function' ? setting(SG_ROOM_FLAG, true) : true) !== false } catch (e) { return true }
}
// hdr — высота полосы заголовка с зазорами (SG_TITLE: top 2 + h 18 + gap 2 × 2) + 2 px до верха узла; nest — зазор между рамкой вложенной группы и полосой родителя
export const SG_ROOM = Object.freeze({ hdr: 26, nest: 2 })   // IE 2026 10 25 / ODOO-348925
// sgTitleRoom: boxes — экранные прямоугольники AttrGraph.rectBoxes ({row, rx, ry, rw, rh}, меняются на месте), nodeTop(key) — экранный верх узла (y − радиус) или null.
// Сначала вложенные (глубже), потом родители: верх родителя — не ниже верха вложенных рамок минус полоса. Подъём не заходит на чужую рамку выше (та же полоса по x,
// не предок и не вложенная): если места под полосу и там нет (масштаб ~0.2 и мельче, группы впритык) — рамка не поднимается и несёт noTitle: заголовок не рисуется
// (AttrGraph.drawGraphContext), его полосы нет и для подписей (titleBandsClear) — ни узел, ни подпись не ложатся под заголовок. Возвращает число поднятых прямоугольников
export function sgTitleRoom(boxes, nodeTop, o = SG_ROOM) {   // IE 2026 10 25 / ODOO-348925
    const all = (Array.isArray(boxes) ? boxes : []).filter((b) => b && b.row)
    const list = all.filter((b) => b.row.titleRoom && b.row.anchor && Array.isArray(b.row.anchor.nodes))
    const depth = (b) => Number(b.row.anchor.depth) || 0
    const sub = (a, b) => a.row.anchor && Array.isArray(a.row.anchor.nodes) && a.row.anchor.nodes.length && a.row.anchor.nodes.every((k) => b.has(k))
    list.sort((a, b) => depth(b) - depth(a))
    let lifted = 0
    for (const b of list) {
        b.noTitle = false
        let top = Infinity
        for (const k of b.row.anchor.nodes) { const y = typeof nodeTop === 'function' ? nodeTop(k) : null; if (Number.isFinite(y)) top = Math.min(top, y) }
        const own = new Set(b.row.anchor.nodes)
        for (const c of list) if (c !== b && depth(c) > depth(b) && sub(c, own)) top = Math.min(top, c.ry - o.nest)
        if (!Number.isFinite(top)) continue
        const need = top - o.hdr
        if (b.ry <= need) continue
        // потолок подъёма: низ чужих рамок выше этой (пересекаются по x), не предков и не вложенных
        let lim = -Infinity
        for (const c of all) {
            if (c === b || c.ry + c.rh > b.ry + 1 || c.rx >= b.rx + b.rw || c.rx + c.rw <= b.rx) continue
            const cs = c.row.anchor && Array.isArray(c.row.anchor.nodes) ? new Set(c.row.anchor.nodes) : null
            if (sub(c, own) || (cs && sub(b, cs))) continue
            lim = Math.max(lim, c.ry + c.rh + o.nest)
        }
        if (need < lim) { b.noTitle = true; continue }
        b.rh += b.ry - need; b.ry = need; lifted++
    }
    return lifted
}

// IE 2026 10 25 / ODOO-348925: подписи связей графа схемы не ложатся друг на друга и на заголовки групп. sigma рисует подпись связи по центру отрезка (drawStraightEdgeLabel):
// у почти параллельных связей в один узел («План введення за рангом» ×4 в «Узгоджений план») подписи накрывают одна другую. Здесь — раскладка кадра: подпись скользит
// вдоль своей связи (места ts), берётся место без наложения на уже поставленные подписи, полосы заголовков групп и узлы; если и лучшее место накрывает подпись
// с ТЕМ ЖЕ текстом — эта подпись не рисуется, у оставшейся — «×n» (n — число связей с этим текстом в стопке). Выключатель fe.ux.schemeGraphEdgeLabels (дефолт ВКЛ):
// выключен — связи без labelDeclutter, подписи рисует sigma как прежде. Изогнутые связи (curvedArrow) рисует своя программа — без изменений.
export const SG_EDGE_FLAG = 'fe.ux.schemeGraphEdgeLabels'   // IE 2026 10 25 / ODOO-348925
export function schemeGraphEdgeLabelsOn(setting) {   // IE 2026 10 25 / ODOO-348925
    try { return (typeof setting === 'function' ? setting(SG_EDGE_FLAG, true) : true) !== false } catch (e) { return true }
}
// IE 2026 10 25 / ODOO-348925 (проба dev02 fe-2026-10-25-12: при отдалении Ctrl+колесом, шаги ×1.5–5, подписи связей у «Узгоджений план» накладываются — кегль подписи
// постоянный, а связи короче): подпись связи, которая и на лучшем месте пересекает другую подпись связи или подпись узла, на этом масштабе не рисуется. Приоритет —
// у подписи узла, между подписями связей — у поставленной раньше (порядок по ключу, кадр от кадра одинаков). Пересчёт — в раскладке кадра (afterRender sigma: на событие
// камеры, не чаще кадра). Выключатель fe.ux.schemeGraphEdgeLabelHide (дефолт ВКЛ): выключен — подписи ставятся как раньше (наложение — только штраф места)
export const SG_EDGE_HIDE_FLAG = 'fe.ux.schemeGraphEdgeLabelHide'   // IE 2026 10 25 / ODOO-348925
export function schemeGraphEdgeLabelHideOn(setting) {   // IE 2026 10 25 / ODOO-348925
    try { return (typeof setting === 'function' ? setting(SG_EDGE_HIDE_FLAG, true) : true) !== false } catch (e) { return true }
}
// ts — места вдоль связи (доля длины), label / title / node — штрафы за наложение, shift — за уход от середины, asc / desc — доли кегля над / под базовой линией
// dedupe — дубли того же текста одной подписью «×n» (false — только места, для сравнения)
// cut — места укороченной подписи у концов (дальше от середины — короче), trunc — штраф за укорачивание (меньше наложения на заголовок)
// nodeLabel — штраф за наложение на подпись узла (IE 2026 10 25 / ODOO-348925: только при ext.labels, см. sgEdgeLabels)
export const SG_EDGE = Object.freeze({ ts: [0.5, 0.36, 0.64, 0.24, 0.76], cut: [0.7, 0.3], label: 10, title: 6, node: 4, nodeLabel: 10, shift: 0.5, trunc: 1.5, asc: 0.85, desc: 0.25, minChars: 4, dedupe: true })   // IE 2026 10 25 / ODOO-348925
// многоугольник прямоугольника подписи: центр (cx, cy), угол, полуширина hw, по нормали — от y0 до y1 (система sigma: текст на y = eSize / 2 + size)
function sgLabelPoly(cx, cy, angle, hw, y0, y1) {
    const c = Math.cos(angle), s = Math.sin(angle)
    return [[-hw, y0], [hw, y0], [hw, y1], [-hw, y1]].map(([x, y]) => [cx + x * c - y * s, cy + x * s + y * c])
}
// пересечение выпуклых многоугольников (теорема о разделяющей оси); касание — не пересечение
export function sgPolyHit(a, b) {
    for (const P of [a, b]) {
        for (let i = 0; i < P.length; i++) {
            const [x1, y1] = P[i], [x2, y2] = P[(i + 1) % P.length]
            const nx = y2 - y1, ny = x1 - x2
            let aMin = Infinity, aMax = -Infinity, bMin = Infinity, bMax = -Infinity
            for (const [x, y] of a) { const v = x * nx + y * ny; if (v < aMin) aMin = v; if (v > aMax) aMax = v }
            for (const [x, y] of b) { const v = x * nx + y * ny; if (v < bMin) bMin = v; if (v > bMax) bMax = v }
            if (aMax <= bMin + 1e-6 || bMax <= aMin + 1e-6) return false
        }
    }
    return true
}
const boxPoly = (b) => [[b.x0, b.y0], [b.x1, b.y0], [b.x1, b.y1], [b.x0, b.y1]]
// обрезка текста под длину отрезка — как у sigma (… с конца); suffix (« ×n») не режется
function sgFitText(base, suffix, d, measure) {
    let label = base + suffix, w = measure(label)
    if (w <= d) return { text: label, w }
    label = base + '…' + suffix; w = measure(label)
    let b = base
    while (w > d && b.length > 1) { b = b.slice(0, -1); label = b + '…' + suffix; w = measure(label) }
    return { text: label, w, cut: true, chars: b.length }
}
// sgEdgeLabels: items — [{key, label, sx, sy, tx, ty, sSize, tSize, eSize}] (экранные px, как sigma передаёт в drawLabel), measure(text) → px шрифтом подписи, size — кегль,
// bands — полосы заголовков групп ({x0, y0, x1, y1}), nodes — [{x, y, r}]. → [{key, text, cx, cy, angle, w, y, hidden, dup, poly}]: рисовать —
// translate(cx, cy), rotate(angle), fillText(text, −w / 2, y). Порядок — по ключу связи (кадр от кадра одинаков)
// IE 2026 10 25 / ODOO-348925: ext.labels — экранные прямоугольники нарисованных подписей узлов ({x0, y0, x1, y1}; место подписи связи их обходит); ext.hide —
// подпись, которая и на лучшем месте пересекает другую подпись связи, подпись узла или полосу заголовка группы (bands), не рисуется (hidden, hit: true; заголовок — title: true)
export function sgEdgeLabels(items, measure, size, bands, nodes, o = SG_EDGE, ext = {}) {   // IE 2026 10 25 / ODOO-348925
    const out = [], placed = []
    const labelPolys = (ext && Array.isArray(ext.labels) ? ext.labels : []).filter((b) => b && [b.x0, b.y0, b.x1, b.y1].every(Number.isFinite)).map(boxPoly)   // IE 2026 10 25 / ODOO-348925
    const hide = !!(ext && ext.hide)   // IE 2026 10 25 / ODOO-348925
    const bandPolys = (Array.isArray(bands) ? bands : []).filter(Boolean).map(boxPoly)
    const nodePolys = (Array.isArray(nodes) ? nodes : []).filter((n) => n && Number.isFinite(n.x) && Number.isFinite(n.y)).map((n) => ({ n, p: boxPoly({ x0: n.x - n.r, y0: n.y - n.r, x1: n.x + n.r, y1: n.y + n.r }) }))
    const list = (Array.isArray(items) ? items : []).filter((it) => it && it.label).slice().sort((a, b) => String(a.key).localeCompare(String(b.key)))
    const times = new Map()   // сколько связей с тем же текстом: у таких место меряется с запасом под « ×n» (оставшаяся подпись станет длиннее)
    for (const it of list) times.set(String(it.label), (times.get(String(it.label)) || 0) + 1)
    for (const it of list) {
        const res = { key: it.key, text: '', cx: 0, cy: 0, angle: 0, w: 0, y: 0, hidden: true, dup: 0, poly: null, base: String(it.label) }
        out.push(res)
        let dx = it.tx - it.sx, dy = it.ty - it.sy, d = Math.hypot(dx, dy)
        if (!(d >= (it.sSize || 0) + (it.tSize || 0)) || !(d > 0)) continue
        const sx = it.sx + dx * (it.sSize || 0) / d, sy = it.sy + dy * (it.sSize || 0) / d, tx = it.tx - dx * (it.tSize || 0) / d, ty = it.ty - dy * (it.tSize || 0) / d
        dx = tx - sx; dy = ty - sy; d = Math.hypot(dx, dy)
        if (!(d > 0)) continue
        const fit = sgFitText(res.base, '', d, measure)
        if (fit.cut && fit.chars + 1 < o.minChars) continue
        const angle = Math.atan2(dy, dx) + (dx > 0 ? 0 : Math.PI)   // текст не вверх ногами — как у sigma
        const y = (it.eSize || 0) / 2 + size, y0 = y - size * o.asc, y1 = y + size * o.desc
        const ux = dx / d, uy = dy / d
        const own = new Set([it.sKey, it.tKey].filter((k) => k !== undefined))
        const n = times.get(res.base) || 1
        const suffixN = n > 1 && o.dedupe !== false ? ` ×${n}` : ''   // запас под « ×n»: оставшаяся подпись станет длиннее
        // места: вдоль связи (ts) полной подписью; у концов (cut) — укороченной «…» под свободную часть связи (как sigma режет длинные; полный текст — в карточке строки связи по клику)
        const cands = o.ts.map((t) => ({ t, cap: d, trunc: 0 })).concat((o.cut || []).map((t) => ({ t, cap: 2 * Math.min(t, 1 - t) * d, trunc: 1 })))
        let best = null
        for (const c of cands) {
            const f = c.trunc ? sgFitText(res.base, suffixN, c.cap, measure) : (suffixN ? sgFitText(res.base, suffixN, d, measure) : fit)
            if (c.trunc && (!f.cut || f.chars + 1 < o.minChars || f.w >= fit.w)) continue   // укорачивать нечего / слишком коротко
            const rw = f.w
            const at = Math.min(Math.max(c.t * d, rw / 2), d - rw / 2)
            const cx = sx + ux * at, cy = sy + uy * at
            const poly = sgLabelPoly(cx, cy, angle, rw / 2, y0, y1)
            let sc = Math.abs(at / d - 0.5) * o.shift + (c.trunc ? o.trunc * (1 + (fit.w - rw) / Math.max(1, fit.w)) : 0), same = null
            for (const p of placed) if (sgPolyHit(poly, p.poly)) { sc += o.label; if (p.base === res.base && !same) same = p }
            for (const bp of bandPolys) if (sgPolyHit(poly, bp)) sc += o.title
            for (const np of nodePolys) if (!own.has(np.n.key) && sgPolyHit(poly, np.p)) sc += o.node
            for (const lp of labelPolys) if (sgPolyHit(poly, lp)) sc += (o.nodeLabel ?? o.label)   // IE 2026 10 25 / ODOO-348925: подпись узла — не под подписью связи
            if (!best || sc < best.sc - 1e-9) best = { sc, cx, cy, poly, same, rw, cap: c.cap }
        }
        if (best.same && o.dedupe !== false) { best.same.dup++; continue }   // та же подпись уже стоит на этом месте — дубль не рисуется, у оставшейся «×n»
        // IE 2026 10 25 / ODOO-348925: и на лучшем месте пересекает подпись узла или другую подпись связи — на этом масштабе не рисуется (приоритет у подписи узла / поставленной раньше)
        if (hide && (labelPolys.some((lp) => sgPolyHit(best.poly, lp)) || placed.some((p) => sgPolyHit(best.poly, p.poly)))) { res.hit = true; continue }
        // IE 2026 10 25 / ODOO-348925 (бой fe-2026-10-25-13: «Статистичний пр…» ушла с подписи «План КАМ» на заголовок «Похідні та довідкові плани», 1734 px²): и на лучшем месте
        // пересекает полосу заголовка группы (bands) — не рисуется; место в обход заголовка выбирается штрафом title выше
        if (hide && bandPolys.some((bp) => sgPolyHit(best.poly, bp))) { res.hit = true; res.title = true; continue }   // IE 2026 10 25 / ODOO-348925
        const shown = sgFitText(res.base, '', best.cap, measure)
        Object.assign(res, { text: shown.text, cx: best.cx, cy: best.cy, angle, w: shown.w, y, hidden: false, poly: best.poly, cap: best.cap, y0, y1, rw: best.rw })
        placed.push(res)
    }
    for (const r of placed) {
        if (!r.dup) continue
        const f = sgFitText(r.base, ` ×${r.dup + 1}`, Math.min(r.cap, Math.max(r.rw, 1)), measure)   // не шире запаса rw: центр тот же, место уже проверено
        r.text = f.text; r.w = f.w
        r.poly = sgLabelPoly(r.cx, r.cy, r.angle, Math.max(f.w, r.rw) / 2, r.y0, r.y1)
    }
    return out
}
export const SG_COLORS = ['#1F6F5B', '#2E6FB5', '#B5651D', '#7A4FB5', '#B53A5A', '#4F7F2E']   // как PALETTE бэка каскада
export const SG_EDGE_COLOR = '#8a94a6'
export const SG_NODE_COLOR = '#6b7fa8'
// иконка узла по виду элемента системы (node.attr_type) — иконки бэка каскада (NODE_ICONS)
export const SG_ICONS = { segment: 'ie-ico-records', source: 'ie-ico-records', ds: 'pi-database', query: 'pi-database', mv: 'pi-database', view: 'pi-database',
    task: 'pi-pen-to-square', 'task-calc': 'pi-pen-to-square', 'task-list': 'ie-ico-fill', 'task-select': 'ie-ico-selector', widget: 'ie-ico-widget', report: 'ie-ico-report' }

const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
export function getPath(obj, path) {
    if (obj === null || obj === undefined || path === null || path === undefined || path === '') return undefined
    let cur = obj
    for (const p of String(path).split('.')) {
        if (cur === null || cur === undefined || typeof cur !== 'object') return undefined
        cur = cur[p]
    }
    return cur
}
// ключ: строка без пробелов по краям; объект ссылки — его value / id; пусто — ''
export function keyOf(v) {
    if (Array.isArray(v)) v = v[0]
    if (isObj(v)) v = v.value !== undefined && v.value !== null && v.value !== '' ? v.value : v.id
    return v === null || v === undefined ? '' : String(v).trim()
}
// поле на языке пользователя (<поле>_<lang>), иначе базовое
export function localized(obj, path, lang) {
    if (!isObj(obj) || !path) return ''
    const loc = lang ? getPath(obj, `${path}_${lang}`) : undefined
    const v = typeof loc === 'string' && loc.trim() !== '' ? loc : getPath(obj, path)
    return v === null || v === undefined || typeof v === 'object' ? '' : String(v)
}

// ---------- конфигурация ----------
const REQUIRED = ['nodes_binding', 'edges_binding']
const DEF = { edges_source_binding: 'source.name', edges_target_binding: 'target.name', nodes_title_binding: 'title', key_binding: 'name', children_path: 'attrs',
    nodes_color_binding: 'color', nodes_use_binding: 'use', nodes_link_binding: 'node', edges_title_binding: '' }
// параметры — ключи верхнего уровня атрибута (запасной — attr.params.<ключ>); errors: [{code, params?}]
export function sgConfig(attr) {
    const a = isObj(attr) ? attr : {}
    const p = isObj(a.params) ? a.params : {}
    const pick = (k) => (typeof a[k] === 'string' ? a[k] : typeof p[k] === 'string' ? p[k] : undefined)
    const cfg = {}
    for (const k of REQUIRED) cfg[k] = (pick(k) || '').trim()
    for (const k of Object.keys(DEF)) { const v = pick(k); cfg[k] = v === undefined ? DEF[k] : v.trim() }
    const nk = pick('nodes_key_binding')   // имя BE (ie-dm7 #104165); key_binding — запасное
    if (nk !== undefined && pick('key_binding') === undefined) cfg.key_binding = nk.trim()
    const errors = []
    const missing = REQUIRED.filter((k) => !cfg[k])
    if (missing.length) errors.push({ code: 'missing', params: missing })
    return { cfg, errors }
}

// ---------- узлы и группы ----------
const kidsOf = (row, cfg) => {
    const k = cfg.children_path ? getPath(row, cfg.children_path) : undefined
    return Array.isArray(k) ? k.filter(isObj) : []
}
// узлы (листья) и группы иерархии doc.nodes. leaves: [{key, gkey, label, color, use, doc, icon, path, groups: [gid…]}]; groups: [{gid, key, title, depth, parent, leaves: [gkey…]}]
export function collectNodes(rows, cfg, lang) {
    const leaves = [], groups = [], byKey = new Map(), groupKeys = new Set(), dupKeys = [], noKey = []
    const walk = (list, path, chain, top) => {
        (Array.isArray(list) ? list : []).forEach((row, i) => {
            if (!isObj(row)) return
            const p = path.concat(i), pid = p.join('.')
            const key = keyOf(getPath(row, cfg.key_binding))
            const title = localized(row, cfg.nodes_title_binding, lang)
            const kids = kidsOf(row, cfg)
            const topIdx = chain.length ? top : i
            if (kids.length) {
                const g = { gid: `g:${pid}`, key, title: title || key, depth: chain.length, parent: chain.length ? chain[chain.length - 1] : null, leaves: [], top: topIdx }
                groups.push(g)
                if (key) groupKeys.add(key)
                walk(kids, p, chain.concat(g.gid), topIdx)
                return
            }
            let gkey
            if (!key) { gkey = `n:#${pid}`; noKey.push(pid) } else if (byKey.has(key)) { gkey = `n:#${pid}`; dupKeys.push(key) } else gkey = `n:${key}`
            const color = getPath(row, cfg.nodes_color_binding)
            const use = cfg.nodes_use_binding ? getPath(row, cfg.nodes_use_binding) : undefined
            const link = cfg.nodes_link_binding ? getPath(row, cfg.nodes_link_binding) : undefined
            const id = isObj(link) ? keyOf(link.value !== undefined ? link.value : link.id) : ''
            const seg = isObj(link) && typeof link.relation_segment === 'string' ? link.relation_segment : ''
            const kind = isObj(link) && typeof link.attr_type === 'string' ? link.attr_type : ''
            const leaf = { key, gkey, label: title || key || '?', color: typeof color === 'string' && color.trim() ? color.trim() : '', use: use !== false, path: pid,
                groups: chain.slice(), top: topIdx, doc: id ? { id, segment: seg || 'SEGMENTS', title: title || key } : null, icon: id ? (SG_ICONS[String(kind).toLowerCase()] || 'pi-circle') : '' }
            leaves.push(leaf)
            if (key && !byKey.has(key)) byKey.set(key, leaf)
            const gset = new Set(chain)
            for (const g of groups) if (gset.has(g.gid)) g.leaves.push(gkey)
        })
    }
    walk(rows, [], [], 0)
    return { leaves, groups, byKey, groupKeys, dupKeys, noKey }
}

// ---------- связи ----------
// edges: [{key, source, target, count, index, label}] (index — первая строка пары); dangling: [{index, source, target, reason: 'missing' | 'group' | 'empty'}]; loops: [{index, key}]
export function collectEdges(rows, nodes, cfg, lang) {
    const byPair = new Map(), dangling = [], loops = []
    ;(Array.isArray(rows) ? rows : []).forEach((row, index) => {
        if (!isObj(row)) return
        const s = keyOf(getPath(row, cfg.edges_source_binding)), t = keyOf(getPath(row, cfg.edges_target_binding))
        const why = (k) => (!k ? 'empty' : nodes.byKey.has(k) ? '' : nodes.groupKeys.has(k) ? 'group' : 'missing')
        const ws = why(s), wt = why(t)
        if (ws || wt) { dangling.push({ index, source: s, target: t, reason: ws || wt }); return }
        if (s === t) { loops.push({ index, key: s }); return }
        const src = nodes.byKey.get(s).gkey, tgt = nodes.byKey.get(t).gkey
        const pk = `${src}->${tgt}`
        const title = cfg.edges_title_binding ? localized(row, cfg.edges_title_binding, lang) : ''
        const e = byPair.get(pk)
        if (e) { e.count++; if (title && !e.titles.includes(title)) e.titles.push(title); return }
        byPair.set(pk, { key: `e:${pk}`, source: src, target: tgt, count: 1, index, titles: title ? [title] : [] })
    })
    const edges = [...byPair.values()].map((e) => ({ ...e, label: [e.titles.join(' | '), e.count > 1 ? `×${e.count}` : ''].filter(Boolean).join(' ') }))
    return { edges, dangling, loops }
}

// ---------- раскладка ----------
const labelW = (label, o) => Math.ceil(String(label || '').length / o.bucket) * o.bucket * o.charW   // ширина подписи — ступенями (bucket символов): мелкая правка названия не перекладывает граф
// подпись раскладки: состав, вложенность, ступени ширины подписей, рёбра — то, от чего зависят координаты
export function layoutSig(nodes, edges, o = SG_LAYOUT) {
    return JSON.stringify([nodes.leaves.map((l) => [l.gkey, l.groups.join('/'), labelW(l.label, o)]), nodes.groups.filter((g) => g.leaves.length).map((g) => [g.gid, g.parent]), edges.map((e) => e.key)])
}
// координаты узлов (центр тела, y вверх) и прямоугольники групп; кластер без узлов — не рисуется
export function layout(nodes, edges, opts) {
    const o = { ...SG_LAYOUT, ...(opts || {}) }
    const g = new dagre.graphlib.Graph({ compound: true, multigraph: false })
    g.setGraph({ rankdir: o.rankdir, ranker: o.ranker, nodesep: o.nodesep, ranksep: o.ranksep, edgesep: o.edgesep, marginx: o.marginx, marginy: o.marginy })
    g.setDefaultEdgeLabel(() => ({}))
    const live = nodes.groups.filter((gr) => gr.leaves.length)
    const compound = o.compound !== false   // false — запасной путь: кластеры не строятся, прямоугольник группы — по габаритам её узлов
    if (compound) for (const gr of live) g.setNode(gr.gid, { label: gr.title })
    if (compound) for (const gr of live) if (gr.parent && g.hasNode(gr.parent)) g.setParent(gr.gid, gr.parent)
    const W = new Map()
    for (const l of nodes.leaves) {
        const w = 2 * o.nodeSize + 6 + (l.icon ? 18 : 0) + labelW(l.label, o) + o.labelPad
        W.set(l.gkey, w)
        g.setNode(l.gkey, { width: w, height: o.nodeH })
        const par = l.groups[l.groups.length - 1]
        if (compound && par && g.hasNode(par)) g.setParent(l.gkey, par)
    }
    for (const e of edges) g.setEdge(e.source, e.target)
    dagre.layout(g)
    const r1 = (v) => Math.round(v * 10) / 10
    const pos = {}
    for (const l of nodes.leaves) {
        const n = g.node(l.gkey)
        pos[l.gkey] = { x: r1(n.x - W.get(l.gkey) / 2 + o.nodeSize + 2), y: r1(-n.y) }   // тело узла — у левого края габарита, подпись — справа (как в AttrGraph)
    }
    const maxDepth = live.reduce((m, gr) => Math.max(m, gr.depth), 0)
    const rects = {}
    const box = (gr) => {   // габарит кластера dagre; без кластеров — по узлам группы
        if (compound) return g.node(gr.gid)
        let a = Infinity, b = -Infinity, c = Infinity, d = -Infinity
        for (const k of gr.leaves) { const n = g.node(k); if (!n) continue; a = Math.min(a, n.x - n.width / 2); b = Math.max(b, n.x + n.width / 2); c = Math.min(c, n.y - n.height / 2); d = Math.max(d, n.y + n.height / 2) }
        return a < b ? { x: (a + b) / 2, y: (c + d) / 2, width: b - a, height: d - c } : null
    }
    for (const gr of live) {
        const n = box(gr)
        if (!n || !(n.width > 0)) continue
        const pad = Math.min(o.rectPad + (maxDepth - gr.depth) * o.rectStep, o.edgesep / 2 - 2)   // внешняя группа — шире вложенной; соседние рамки dagre разводит на edgesep — поля не сходятся
        rects[gr.gid] = { x0: r1(n.x - n.width / 2 - pad), x1: r1(n.x + n.width / 2 + pad), y0: r1(-(n.y - n.height / 2 - pad)), y1: r1(-(n.y + n.height / 2 + pad)) }
    }
    return { pos, rects }
}

// ---------- сборка data_graph ----------
// nodesRows / edgesRows — строки табличных частей; cfg — sgConfig; lang — '' | 'uk' | 'ru'; opts.cache — объект компонента ({sig, pos, rects}): та же раскладка — те же координаты
// (AttrGraph тогда обновляет подписи и цвета точечно, без перераскладки — tryPatchGraph). Результат: { data_graph, stats, dangling, loops, dupKeys, noKey }
// IE 2026 10 25 / ODOO-348925: opts.titleClear === false (fe.ux.schemeGraphTitleClear выключен) — прямоугольники групп без labelClear
// IE 2026 10 25 / ODOO-348925: opts.edgeLabelHide === false (fe.ux.schemeGraphEdgeLabelHide) — связи без labelHide (подписи с наложением рисуются, как раньше)
// IE 2026 10 25 / ODOO-348925: opts.titleRoom === false (fe.ux.schemeGraphTitleRoom) — без titleRoom; opts.edgeLabels === false (fe.ux.schemeGraphEdgeLabels) — связи без labelDeclutter
export function buildSchemeGraph(nodesRows, edgesRows, cfg, lang, opts = {}) {
    const nodes = collectNodes(nodesRows, cfg, lang)
    const ed = collectEdges(edgesRows, nodes, cfg, lang)
    const sig = layoutSig(nodes, ed.edges, { ...SG_LAYOUT, ...(opts.layout || {}) })
    const cache = isObj(opts.cache) ? opts.cache : {}
    let relaid = false
    if (cache.sig !== sig || !cache.pos) {
        let L
        try { L = layout(nodes, ed.edges, opts.layout) } catch (e) {   // dagre не разложил кластеры — те же узлы без кластеров, прямоугольники по узлам групп
            if (typeof opts.warn === 'function') opts.warn('[AttrSchemeGraph] compound layout failed, groups are drawn around their nodes', e)
            L = layout(nodes, ed.edges, { ...(opts.layout || {}), compound: false })
        }
        cache.sig = sig; cache.pos = L.pos; cache.rects = L.rects; relaid = true
    }
    const pos = cache.pos, rects = cache.rects || {}
    const outNodes = nodes.leaves.map((l) => ({
        key: l.gkey,
        attributes: {
            label: l.label, x: pos[l.gkey].x, y: pos[l.gkey].y, size: SG_LAYOUT.nodeSize, forceLabel: true,
            color: l.color || SG_COLORS[l.top % SG_COLORS.length] || SG_NODE_COLOR,
            ...(l.icon ? { icon: l.icon } : {}),
            ...(l.use ? {} : { hollow: true }),   // use = false — пустое тело (как узел вне модели каскада), узел не скрывается
            row: { binding: cfg.nodes_binding, rid: l.key, key_binding: cfg.key_binding, children_path: cfg.children_path },
            ...(l.doc ? { doc: l.doc } : {}),
        },
    }))
    const outEdges = ed.edges.map((e) => {
        const back = pos[e.target].x < pos[e.source].x   // связь назад по слоям (цикл) — дугой, как обратные связи каскада
        return { key: e.key, source: e.source, target: e.target,
            attributes: { size: e.count > 1 ? 2.4 : 1.8, color: SG_EDGE_COLOR, label: e.label, ...(back ? { type: 'curvedArrow', curvature: 0.35 } : {}),
                ...(opts.edgeLabels !== false ? { labelDeclutter: true } : {}),   // IE 2026 10 25 / ODOO-348925: подпись связи — раскладкой кадра (AttrGraph.drawEdgeLabelsQ)
                ...(opts.edgeLabels !== false && opts.edgeLabelHide !== false ? { labelHide: true } : {}),   // IE 2026 10 25 / ODOO-348925: наложение на подпись узла / связи — не рисуется
                row: { binding: cfg.edges_binding, rid: String(e.index), index: e.index } } }
    })
    const ctx = []
    for (const gr of [...nodes.groups].sort((a, b) => a.depth - b.depth)) {
        const r = rects[gr.gid]
        if (!r || !gr.leaves.length) continue
        ctx.push({ type: 'rect', ...r, title: gr.title, fillStyle: 'rgba(120, 130, 150, 0.06)', strokeStyle: 'rgba(120, 130, 150, 0.55)', lineWidth: 1, lineDash: [3, 3],
            font: gr.depth ? '11px sans-serif' : '600 12px sans-serif', textStyle: '#5b6470', anchor: { nodes: gr.leaves.slice(), depth: gr.depth },
            ...(opts.titleClear !== false ? { labelClear: true } : {}),   // IE 2026 10 25 / ODOO-348925: подписи узлов обходят заголовок (AttrGraph.labelPlace)
            ...(opts.titleRoom !== false ? { titleRoom: true } : {}),   // IE 2026 10 25 / ODOO-348925: запас под заголовок в экранных px (AttrGraph.rectBoxes, sgTitleRoom)
            ...(gr.key ? { row: { binding: cfg.nodes_binding, rid: gr.key, key_binding: cfg.key_binding, children_path: cfg.children_path } } : {}) })
    }
    return {
        data_graph: { nodes: outNodes, edges: outEdges, graphContext: ctx, legend: { items: [] } },
        stats: { nodes: outNodes.length, groups: ctx.length, edges: outEdges.length, dangling: ed.dangling.length, loops: ed.loops.length, relaid },
        dangling: ed.dangling, loops: ed.loops, dupKeys: nodes.dupKeys, noKey: nodes.noKey,
    }
}

// подпись всего, что влияет на картинку (для $watch компонента): ключи, подписи на языке, вложенность, цвет, use, ссылка на элемент, концы и подписи связей
export function structSig(nodesRows, edgesRows, cfg, lang) {
    const walk = (list) => (Array.isArray(list) ? list : []).filter(isObj).map((r) => {
        const link = cfg.nodes_link_binding ? getPath(r, cfg.nodes_link_binding) : undefined
        return [keyOf(getPath(r, cfg.key_binding)), localized(r, cfg.nodes_title_binding, lang), String(getPath(r, cfg.nodes_color_binding) ?? ''),
            cfg.nodes_use_binding ? getPath(r, cfg.nodes_use_binding) === false : false,
            isObj(link) ? [keyOf(link.value !== undefined ? link.value : link.id), String(link.relation_segment ?? ''), String(link.attr_type ?? '')] : '', walk(kidsOf(r, cfg))]
    })
    const e = (Array.isArray(edgesRows) ? edgesRows : []).map((r) => (isObj(r) ? [keyOf(getPath(r, cfg.edges_source_binding)), keyOf(getPath(r, cfg.edges_target_binding)),
        cfg.edges_title_binding ? localized(r, cfg.edges_title_binding, lang) : ''] : null))
    return JSON.stringify([lang || '', cfg, walk(nodesRows), e])
}

// строка табличной части по ссылке row узла / ребра / группы графа: index — позиция в плоской таблице (связи), key_binding — ключ (узлы и группы, по вложенности)
export function findRow(data, row) {
    if (!row || !Array.isArray(data)) return null
    if (row.index !== undefined && row.index !== null) { const it = data[Number(row.index)]; return isObj(it) ? it : null }
    if (!row.key_binding) return null
    const kp = row.children_path || 'attrs', rid = String(row.rid ?? '')
    const walk = (list) => {
        for (const it of Array.isArray(list) ? list : []) {
            if (!isObj(it)) continue
            if (keyOf(getPath(it, row.key_binding)) === rid) return it
            const f = walk(getPath(it, kp))
            if (f) return f
        }
        return null
    }
    return rid ? walk(data) : null
}

// одно предупреждение в консоль на набор висячих связей (тот же набор повторно не печатается): last — подпись прошлого предупреждения; возвращает новую подпись
export function warnDangling(dangling, last, warn = (...a) => console.warn(...a)) {
    const list = Array.isArray(dangling) ? dangling : []
    const sig = JSON.stringify(list.map((d) => [d.index, d.source, d.target, d.reason]))
    if (!list.length || sig === last) return list.length ? sig : ''
    warn(`[AttrSchemeGraph] ${list.length} link(s) skipped: an end is not a node of the scheme`, list.map((d) => `#${d.index} ${d.source || '∅'} → ${d.target || '∅'} (${d.reason})`).join('; '))
    return sig
}
